export default "__VITE_ASSET__BVCshEKB__"